import type { NetworkSettingsConfig } from '@/config/config.types';
import { parseProtocolProfile } from '@/lib/protocol-profile';

import { get } from '../http';

export const PROTOCOL_PROFILE_TIMEOUT_MS = 8_000;

export async function fetchProtoProfile(config: NetworkSettingsConfig, signal?: AbortSignal) {
  // The app server reads its configured validator. Browser access to a separate
  // validator domain must not leave wallet connection spinning indefinitely.
  const data = await get<unknown>('/api/protocol-profile', { network: config.network }, { signal, timeoutMs: PROTOCOL_PROFILE_TIMEOUT_MS });
  return parseProtocolProfile(data, config.network);
}
